import { NgModule } from '@angular/core';
import { EditModalLayoutComponent } from './edit-modal-layout.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    EditModalLayoutComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatIconModule,
  ],
  exports: [
    EditModalLayoutComponent,
  ],
})
export class EditModalLayoutModule {
}
